/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BattleRadar.css';
import ReactEcharts from 'echarts-for-react'

class BattleRadar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
    this.getOption = this
      .getOption
      .bind(this)
  }

  getOption = () => {

    // var data = [     {         value: [             20, 40, 50         ],
    // name: '腾讯',         isTrue: false     } ];

    // let data1 = this.props.json;

    let data1=this.props.json

  // isTrue:true为实线，好感度为正值，false为虚线，好感度为负值


    

    let [legendArr,radar22,maxNum]=[[],[],0]
    
        data1.forEach((i)=>{

         
          i.value.map(i=>maxNum=maxNum>Number(i)?maxNum:i)
          // console.log(maxSp,'--',i.value[0],'||',maxPa,'--',i.value[1],'||',maxFa,'--',i.value[2])
          
          radar22.push({
            name:i.name,
            value:i.value,
            lineStyle:{
              normal:{
                type:i.isTrue?'solid':'dashed',
                width:3
              }
            },
            itemStyle:{
              normal:{
                borderWidth:2
              }
            }
          })
          legendArr.push(i.name)
          
        })

    // console.log(radar22)


    // console.log(isYellowColor)
    const option = {
      color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
      
      toolbox: {
        show: true,
        feature: {
          mark: {
            show: true
          },
          //          dataView : {show: true, readOnly: false},
          magicType: {
            show: true,
            type: ['pie', 'funnel']
          },
          restore: {
            show: true
          },
          saveAsImage: {
            show: true
          }
        },
        right: 20
      },
      
      title: {
        text: `品牌三维图 - ${legendArr.join(' vs ')}`,
        left: 20,
        // sublink:'',
        subtext: '数据来源：数字品牌榜'
      },
      tooltip: {
        formatter: function (params, data) {
          var item = params.data.item

          let ss = (`${params.data.name}<br/>传播度:${params.value[0]}%<br/>参与度:${params.value[1]}%<br/>好感度:${params.value[2]}%<br/>`)
          // console.log(ss)
          
          return ss;

        }
      },
      legend: {
        data:legendArr
      },
      graphic: [
        {
          type: 'rect',
          z: 100,
          left: '20',
          top: '60',
          shape: {
            width: 240,
            height: 36
          },
          style: {
            fill: '#ffd70d',
            stroke: '#999'
          }
        }, {
          type: 'text',
          left: '20',
          top: 65,
          z: 100,
          style: {
            text: ' ● 三维线段为实线，表明好感度为正值；',
            // fill:'#ffd70d',
            stroke: '#ffd70d',
            font: '12px "STHeiti", sans-serif'
          }
        }, {
          type: 'text',
          left: '20',
          top: 80,
          z: 100,
          style: {
            text: '    若为虚线，表明好感度为负值。',
            // fill:'#ffd70d',
            stroke: '#ffd70d',
            font: '12px "STHeiti", sans-serif'
          }
        }

      ],
      radar: {
        // shape: 'circle',
        name:{
          fontSize:14
        },
        indicator: [
          {
            name: '传播度',
            max:maxNum<=90?Number(maxNum)+10:maxNum
            
          }, {
            name: '参与度',
            max: maxNum<=90?Number(maxNum)+10:maxNum
          }, {
            name: '好感度',
            max: maxNum<=90?Number(maxNum)+10:maxNum
          }
        ],
        center: ['50%', '60%'],
        splitArea: {
          show: false
        },
      },
      series: [
        {
          name: 'DB值',
          type: 'radar',
          // lineStyle:{
          //   normal:{
          //     type:`${isLine}`
          //   }
          // },
          data: radar22
        }
      ]
    };
    return option
  }

  render() {
    return (<ReactEcharts
      option={this.getOption()}
      style={{
      height: '550px',
      width:'100%',
      
      borderRadius: '4px'
    }}
      className={s.charts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={this.onChartReadyCallback}/>)

  }
}

export default withStyles(s)(BattleRadar);



// WEBPACK FOOTER //
// src/components/BattleRadar/BattleRadar.js